import React, { useEffect, useState } from 'react';
import App from './App';
import AdminApp from './AdminApp';
import MaintenancePage from './pages/MaintenancePage';
import {
  fetchMaintenanceEnabled,
  readMaintenanceCache,
} from './siteMaintenance';
import './pages/MaintenancePage.css';

const envMaintenanceOn = process.env.REACT_APP_MAINTENANCE_MODE === 'true';

const BootstrapChecking: React.FC = () => (
  <main className="maintenance-page bootstrap-checking" role="main" aria-busy="true">
    <div className="maintenance-page__overlay" aria-hidden="true" />
    <div className="maintenance-content">
      <p className="maintenance-sub" style={{ marginBottom: '1rem' }}>
        Comprobando disponibilidad del sitio…
      </p>
      <div
        className="route-fallback-spinner"
        style={{ margin: '0 auto', width: 40, height: 40, borderWidth: 3 }}
        aria-hidden="true"
      />
      <p className="maintenance-contact-intro" style={{ marginTop: '1.25rem' }}>
        Si activaste el modo mantenimiento, la pantalla correcta aparecerá en breve.
      </p>
    </div>
  </main>
);

/**
 * Raíz: /admin siempre carga el panel. El resto consulta el flag en API (sin rebuild).
 * Si el fetch falla o tarda, usa caché local o muestra mantenimiento (backend saturado).
 * REACT_APP_MAINTENANCE_MODE actúa como OR de emergencia (rebuild).
 */
const BootstrapRoot: React.FC = () => {
  const [isAdminRoute] = useState(() => window.location.pathname.startsWith('/admin'));
  const [apiMaintenance, setApiMaintenance] = useState<boolean | null>(() => {
    if (isAdminRoute || envMaintenanceOn) return false;
    return readMaintenanceCache();
  });

  useEffect(() => {
    if (isAdminRoute || envMaintenanceOn) return;
    let cancelled = false;

    fetchMaintenanceEnabled()
      .then((enabled) => {
        if (!cancelled) setApiMaintenance(enabled);
      })
      .catch(() => {
        if (cancelled) return;
        const cached = readMaintenanceCache();
        // Sin respuesta del API (saturado/caído): preferir caché o mantenimiento
        // para no dejar la web en "Cargando…" indefinidamente.
        setApiMaintenance(cached ?? true);
      });

    return () => {
      cancelled = true;
    };
  }, [isAdminRoute]);

  if (isAdminRoute) {
    return <AdminApp />;
  }

  if (apiMaintenance === null) {
    return <BootstrapChecking />;
  }

  if (envMaintenanceOn || apiMaintenance) {
    return <MaintenancePage />;
  }

  return <App />;
};

export default BootstrapRoot;
